import type {
  LockAccessCode,
  LockAccessCodesResponse,
  LockAccessHistory,
  LockActionResponse,
  LockBattery,
  LockDevice,
  LockStatus,
} from '@interfaces/lock.interface';
import type { PagedResponse } from '@interfaces/response.interface';

import { mockDb } from '../mock-db';

export function getLocksByRentalIdMock(rentalId: string): { devices: LockDevice[] } {
  return { devices: mockDb.getLockDevices(rentalId) };
}

export function getLockByIdMock(id: string): LockDevice | undefined {
  return mockDb.getLockDeviceById(id);
}

export function getAccessCodesByLockIdMock(_lockId: string): LockAccessCode[] {
  return mockDb.getAccessCodes();
}

export function getAccessHistoryByLockIdMock(_lockId: string): LockAccessHistory[] {
  return mockDb.getAccessHistory();
}

export function createLockMock(data?: Partial<LockDevice>): LockDevice {
  const base = mockDb.lockDevices[0];
  return { ...base, deviceId: `lock-${Date.now()}`, ...data };
}

export function updateLockMock(id: string, data: Partial<LockDevice>): LockDevice {
  const base = mockDb.lockDevices[0];
  return { ...base, deviceId: id, ...data };
}

export function deleteLockMock(): { success: boolean } {
  return { success: true };
}

export function getAllLocksMock(): { devices: LockDevice[] } {
  return { devices: mockDb.getLockDevices() };
}

export function getLockBatteryByRentalIdMock(rentalId: string): LockBattery {
  return mockDb.getLockBattery(rentalId);
}

export function getBridgeStatusByRentalIdMock(_rentalId: string): LockStatus {
  return mockDb.getLockBridgeStatus();
}

export function getAccessCodesByRentalIdMock(_rentalId: string): LockAccessCodesResponse {
  return mockDb.getAccessCodesResponse();
}

export function createAccessCodeByRentalIdMock(_rentalId: string): { success: boolean } {
  return { success: true };
}

export function getAccessHistoryByRentalIdMock(
  _rentalId: string,
  page = 0,
  size = 20
): PagedResponse<LockAccessHistory> {
  return mockDb.getPagedAccessHistory(page, size);
}

export function unlockByRentalIdMock(rentalId: string): LockActionResponse {
  return mockDb.getLockActionResponse(rentalId);
}

export function lockByRentalIdMock(rentalId: string): LockActionResponse {
  return mockDb.getLockActionResponse(rentalId);
}

export function deleteAccessCodeByRentalIdMock(
  _rentalId: string,
  _passcodeId: string
): { success: boolean } {
  return { success: true };
}

export function getLockStatusByRentalIdMock(_rentalId: string): {
  state: string;
  error: string | null;
} {
  return mockDb.getLockConnectionStatus();
}
